var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "align-center": "", "justify-center": "" } },
        [
          _c(
            "v-card",
            { attrs: { elevation: "2", width: "500" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mx-3 my-3",
                  attrs: { dense: "", type: _vm.alertType },
                  model: {
                    value: _vm.alert,
                    callback: function($$v) {
                      _vm.alert = $$v
                    },
                    expression: "alert"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.message) + " ")]
              ),
              _c("v-card-title", [_vm._v(" Reset Password ")]),
              _c("v-card-subtitle", [
                _vm._v(" Please enter your new password. ")
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "resetPasswordForm",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          label: "Email",
                          rules: [_vm.rules.required, _vm.rules.email]
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email = $$v
                          },
                          expression: "email"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          counter: 8,
                          rules: [_vm.rules.required, _vm.rules.password],
                          label: "Password",
                          type: _vm.show ? "text" : "password",
                          "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off"
                        },
                        on: {
                          "click:append": function($event) {
                            _vm.show = !_vm.show
                          }
                        },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password = $$v
                          },
                          expression: "password"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          dense: "",
                          outlined: "",
                          rules: [_vm.rules.required, _vm.rules.confirm],
                          label: "Confirm Password",
                          type: _vm.show ? "text" : "password",
                          "append-icon": _vm.show ? "mdi-eye" : "mdi-eye-off"
                        },
                        on: {
                          "click:append": function($event) {
                            _vm.show = !_vm.show
                          }
                        },
                        model: {
                          value: _vm.password_confirm,
                          callback: function($$v) {
                            _vm.password_confirm = $$v
                          },
                          expression: "password_confirm"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    },
                    [_vm._v(" Back to Login ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: !_vm.valid, color: "primary" },
                      on: { click: _vm.submitForm }
                    },
                    [_vm._v(" Reset ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }